import { CountyFilterFields } from "modules/common";
import React, { useContext, useMemo } from "react";
import { Filter, Loading, OptionType, ToggleSwitch } from "../";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: number[];
    isEnum?: boolean;
    counties?: OptionType<number | null>[];
    isLoadingCounties?: boolean;
}

export const CountyFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
    isEnum = true,
    counties,
    isLoadingCounties,
}) => {
    const countyFilterFields = useMemo(
        () =>
            Object.keys(CountyFilterFields).sort((a, b) =>
                CountyFilterFields[a].label > CountyFilterFields[b].label ? 1 : -1
            ),
        []
    );
    const { lowVision } = useContext(AccessibilityContext);
    const renderFilter = useMemo(() => {
        if (isEnum)
            return countyFilterFields.map((key, index, _arr) => (
                <div key={index}>
                    <ToggleSwitch
                        value={CountyFilterFields[key].value.toString()}
                        checked={value.includes(CountyFilterFields[key].value)}
                        onChange={onChange}
                        htmlFor={key}
                        text={
                            <div
                                className={
                                    lowVision ? "low-vision-white-text" : "filter__item__text"
                                }
                            >
                                {CountyFilterFields[key].label.toLocaleUpperCase()}
                            </div>
                        }
                    />
                </div>
            ));
        else {
            if (isLoadingCounties) return <Loading size="small" />;
            else if (counties?.length)
                return counties?.map(({ label, value: countyId }) => {
                    return (
                        <div key={label}>
                            <ToggleSwitch
                                value={countyId?.toString()}
                                checked={value.includes(countyId!)}
                                onChange={onChange}
                                htmlFor={label}
                                text={
                                    <div
                                        className={
                                            lowVision
                                                ? "low-vision-white-text"
                                                : "filter__item__text"
                                        }
                                    >
                                        {label.toLocaleUpperCase()}
                                    </div>
                                }
                            />
                        </div>
                    );
                });

            return <p>Nema podataka</p>;
        }
    }, [counties, countyFilterFields, isLoadingCounties, value]);

    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClear={onClear}
            onClick={onClick}
            text="ŽUPANIJA"
        >
            {renderFilter}
        </Filter>
    );
};
